import store from './store'
import axios from 'axios';
import router from '../router/index'
//测试环境
// const baseURL = 'http://52jz.natapp4.cc/exam'
// const showUploadURL = 'http://52jz.natapp4.cc/data/exam/'//图片显示前缀
// const examTemplate = 'http://52jz.natapp4.cc/data/exam/questionsTmpl.xlsx'//excle模板地址
// export const routerMode ='hash'//路由模型

//正式环境
// const baseURL = 'https://org.yindanjiafu.com/exam'
// const showUploadURL = 'https://org.yindanjiafu.com/'//图片显示前缀
// const examTemplate = 'https://org.yindanjiafu.com/questionsTmpl.xlsx'//excle模板地址
// export const routerMode = 'history'//路由模型

const baseURL = 'https://org.zhongjiapx.com/exam'
const showUploadURL = 'https://org.zhongjiapx.com/'//图片显示前缀
const examTemplate = 'https://org.zhongjiapx.com/questionsTmpl.xlsx'//excle模板地址
export const routerMode = 'history'//路由模型 

//正式环境
// const baseURL = 'http://47.106.151.191/exam'
// const showUploadURL = 'http://47.106.151.191/'//图片显示前缀
// const examTemplate = 'http://47.106.151.191/questionsTmpl.xlsx'//excle模板地址
// export const routerMode = 'history'//路由模型

window.baseURL = baseURL
window.showUploadURL = showUploadURL
window.examTemplate = examTemplate
window.downExamList = baseURL + '/backExamine/exportInfo'//导出考试记录excle
window.uploadURL = baseURL + '/login/uploadFile'//上传图片地址
import { Loading } from 'element-ui';
import { Notice } from 'iview'
import 'element-ui/lib/theme-chalk/index.css'
const instance = axios.create({
  baseURL
})
let loading;
let loadingCount = 0;
//开始loading
function startLoading() {
  if (loadingCount == 0) {
    loading = Loading.service({
      fullscreen: false,
      text: '加载中',
      background: 'transparent'
    });
  }
  loadingCount++
}
//结束loading
function endLoading() {
  loadingCount--
  if (loadingCount == 0) {
    loading.close();
  }
}
//请求拦截
instance.interceptors.request.use(
  config => {
    startLoading()
    return config
  },
  error => {
    console.log(error);
    loading.close();
    return Promise.reject(error)
  }
)
// 响应拦截
instance.interceptors.response.use(
  response => {
    endLoading()
    if (response.data) {
      if (response.data.responseCode == "100") {
        return response.data.data
      } else if (response.data.responseCode == "300") {
        loading.close();
        // Notice.warning({
        //   title: '提示',
        //   desc: response.data.responseMsg
        // });
        router.replace({ path: "/" })
      } else {
        loading.close();
        Notice.warning({
          title: '提示',
          desc: response.data.responseMsg
        });
      }
    } else {
      return Promise.reject('error')
    }
  },
  error => {
    loading.close();
    Notice.warning({
      title: '提示',
      desc: '请求失败，请检查你的网络'
    });
    return Promise.reject(error)
  }
)
// 请求封装
export function get(url, params) {
  // params.loginUserId = store.state.userInfo.loginUserId
  // params.loginToken = store.state.userInfo.loginToken
  // params.organizationLoginKey = organKey
  return instance.get(url, {
    headers: {
      'loginUserId': store.state.userInfo.loginUserId,
      "loginToken": store.state.userInfo.loginToken,
    },
    params
  })
}
export function post(url, data, isProve = true) {
  // if (isProve) {
  //   data.loginUserId = store.state.userInfo.loginUserId
  //   data.loginToken = store.state.userInfo.loginToken
  // }
  //data.organizationLoginKey = organKey
  return instance.post(url, data, {
    transformRequest: [
      function (data) {
        let str = ""
        for (let key in data) {
          str += encodeURIComponent(key) +
            "="
            + encodeURIComponent(data[key]) + '&'
        }
        return str
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "loginUserId": store.state.userInfo.loginUserId || "",
      "loginToken": store.state.userInfo.loginToken || "",
    }
  })

}

export function uploadExcle(url, data) {
  // data.append('loginUserId', store.state.userInfo.loginUserId)
  // data.append('loginToken', store.state.userInfo.loginToken)
  // data.append('organizationLoginKey', organKey)
  return instance.post(url, data, {
    transformRequest: [data => data],
    headers: {
      'Content-Type': 'multipart/form-data',
      'loginUserId': store.state.userInfo.loginUserId,
      "loginToken": store.state.userInfo.loginToken,
    }

  })
}


// WEBPACK FOOTER //
// ./src/config/fetch.js